import React from 'react';
import { get } from 'lodash';
import { styled, css, Flex } from '@goodrx/matisse';
import Tenancy from 'app/lib/tenancy';
import { mediaMaxWidth } from 'app/lib/utils';

const Logo = styled.img`
  height: ${(p: any) => get(p.theme, 'components.header.logoHeight', 30)}px;

  ${mediaMaxWidth({
    sm: css`
      height: ${(p: any) => get(p.theme, 'components.header.logoHeightMobile', 30)}px;
    `,
  })}
`;

const AppLogo = () => {
  return (
    <Flex alignItems="center">
      <Logo src={Tenancy.getLogoSrc()} />
    </Flex>
  );
};

export default AppLogo;
